import { render, staticRenderFns } from "./ChangeCommonFields.vue?vue&type=template&id=19b02b78&"
import script from "./ChangeCommonFields.vue?vue&type=script&lang=js&"
export * from "./ChangeCommonFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports